import { render, staticRenderFns } from "./InventoryBalance.vue?vue&type=template&id=bfec4cc6"
import script from "./InventoryBalance.vue?vue&type=script&lang=js"
export * from "./InventoryBalance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports